let config = null;

export function setConfig(c) {
  config = c;
}

export function getConfig() {
  if (!config) {
    throw new Error("Configurazione non caricata!");
  }
  return config;
}
